<div *ngIf="!noInternetConnection" class="connection-status online-mode">    
  <h1 style="margin-bottom: 20px;">Online mode</h1>  
</div>
<div *ngIf="noInternetConnection" class="connection-status offline-mode">    
  <h1 style="margin-bottom: 20px;">Offline mode</h1>  
</div>
<router-outlet></router-outlet>
